import GrpcRioClient from '.';
import { noWindow } from '../../utils';
var initClient = function initClient() {
  if (!noWindow() && !window.rioClient2 && !GrpcRioClient.isInit) {
    GrpcRioClient.isInit = true;
    window.rioClient2 = new GrpcRioClient();
  }
};
export default initClient;